import r from"./arrayLikeToArray.js";function a(a){if(Array.isArray(a))return r(a)}export{a as default};
//# sourceMappingURL=arrayWithoutHoles.js.map
